import ConfirmPayment from "./ConfirmPayment";

export default ConfirmPayment;
